import { Dispatch, SetStateAction } from "react";
import { IconButton, Tooltip } from "@mui/material";
import BarChartIcon from "@mui/icons-material/BarChart";
import GridOnIcon from "@mui/icons-material/GridOn";

export const SetChartView = (props: {
  isChartView: boolean;
  setIsChartView: Dispatch<SetStateAction<boolean>>;
  isLoading: boolean;
}) => {
  const { isChartView, setIsChartView, isLoading } = props;

  return (
    <Tooltip title={isChartView ? "View as pivot" : "View as chart"}>
      <IconButton
        onClick={() => setIsChartView((prev: boolean) => !prev)}
        disabled={isLoading}
        sx={{
          mt: 0.5,
        }}
      >
        {isChartView ? <GridOnIcon /> : <BarChartIcon />}
      </IconButton>
    </Tooltip>
  );
};
